export const MATCHING_FIELD_FARM_NAME_WITHOUT_OVERLAP = "matchingFieldFarmNameWithoutOverlap";
export const MATCHING_ARCHIVED_FIELD_FARM_NAME_WITHOUT_OVERLAP =
    "matchingArchivedFieldFarmNameWithoutOverlap";
